import { render, staticRenderFns } from "./EPayTransaction.vue?vue&type=template&id=21bdf664&"
import script from "./EPayTransaction.vue?vue&type=script&lang=js&"
export * from "./EPayTransaction.vue?vue&type=script&lang=js&"
import style0 from "./EPayTransaction.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports